import type { CohesionGlobal } from '@strata-monorepo/shared-types/src/window'
import type { Address } from '@strata-monorepo/shared-ui/types/Address'
import { withRetry } from '@strata-monorepo/shared-ui/utils/retryUtil'

import { getStrataApiBaseUrl } from '@strata-monorepo/utils/getStrataApiBaseUrl'
import { mockWebContext } from '../mock/web-context'
import { store } from '@strata-monorepo/find-my-plan/lib/store/useStore'
import { createAppropriateMetricsClient } from '../hooks/useMetrics'

const enrichCustomerData = async (cohesionData: CohesionGlobal, addressData: Address) => {
  const dsAddressFormat = {
    address: addressData.street_line,
    address2: addressData.secondary,
    city: addressData.city || '',
    state: addressData.state || '',
    zip: addressData.zipcode,
  }

  let webContext = cohesionData.webContext
  if (!webContext && process.env.NODE_ENV === 'development') {
    webContext = mockWebContext
  }

  try {
    const baseUrl = getStrataApiBaseUrl()
    const url = `${baseUrl}/api/v1/ds/enrich-customer`

    const { metricsClient, isMetricsProviderLoaded } = store.getState().metrics
    const client = isMetricsProviderLoaded ? metricsClient : createAppropriateMetricsClient()

    const { result: res } = await withRetry(
      async () => {
        return await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            webContext,
            address: dsAddressFormat,
          }),
        })
      },
      {
        maxRetries: 3,
        baseDelay: 500,
        logAttempts: false,
      },
      {
        requestName: 'FetchEnrichCustomer',
        metricsClient: client,
      },
    )
    if (!res.ok) {
      throw new Error(`Request failed with status ${res.status}`)
    }

    const response = await res.json()
    return response.data
  } catch (error) {
    throw error
  }
}

export default enrichCustomerData
